import { render, staticRenderFns } from "./create-group-teams.html?vue&type=template&id=34321c22&scoped=true&external"
import script from "./create-group-teams.js?vue&type=script&lang=js&external"
export * from "./create-group-teams.js?vue&type=script&lang=js&external"
import style0 from "./create-group-teams.scss?vue&type=style&index=0&id=34321c22&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34321c22",
  null
  
)

export default component.exports